import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SvgIcon } from "../../Icon";
import { BulletItemContainer, BulletItemContent } from "../List.styles";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BulletItem = function(param) {
    var item = param.item, _type = param.type;
    return /*#__PURE__*/ _jsxs(BulletItemContainer, {
        children: [
            /*#__PURE__*/ _jsx(SvgIcon, {
                name: "check"
            }),
            /*#__PURE__*/ _jsx(BulletItemContent, {
                children: item
            })
        ]
    });
};
export { BulletItem };
